

document.addEventListener('DOMContentLoaded', () => {

  window.addEventListener('popstate', function (event) {
    if (history.state && history.state.id === 'filter') {
      location.reload();
    }
  }, false);

  function filterLoadUrl(url) {

    document.querySelector('.filter-results').classList.add('is-loading');

    currentUrl = url;

    fetch(url)
    .then(function(response) {
        return response.text();
    })
    .then(function(html) {

        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");

        // push state
        if (typeof keepUrl == 'undefined') {
          var title = doc.querySelector('title').textContent;
          window.history.pushState({
            id: 'filter'
          }, title, url);
          document.title = title;
        }

        document.querySelector('.filter-results').innerHTML = doc.querySelector('.filter-results').innerHTML;
        document.querySelector('.filter-results').classList.remove('is-loading');

        // init filter
        filterInit();

        // activate block links
        document.querySelectorAll('.block-link').forEach(el => {
          el.addEventListener('click', function(e) {
            el.querySelector('a').click();
          });
        });

    })
    .catch(function(err) {
        console.log('Failed to fetch page: ', err);
    });

  }

  function filterSearch(jumpToUrl = false) {

    var params = new Object();
    var query = new Object();

    // loop through inputs to find values
    document.querySelectorAll('.filter').forEach(el => {
      if (el.querySelector('.input')) {
        var id = el.getAttribute('data-id');
        var type = el.getAttribute('data-type');
        var val = el.querySelector('.input').value;
        if (val) {
          if (type == 'query') {
            query[id] = val;
          } else {
            params[id] = val;
          }
        }
        el.classList.toggle('is-active', val);
      }
    });

    // make url
    var globalParamsOrder = ['month', 'issue', 'school', 'category', 'page'];
    var url = rootUrl;
    var sep = '';
    globalParamsOrder.forEach(key => {
      if (params[key] !== undefined) {
        url += sep + key;
        sep = '/';
        url += sep + params[key];
      }
    });
    for (var key in params) {
      if (params.hasOwnProperty(key)) {
        if (params[key] !== undefined && globalParamsOrder.indexOf(key) == -1) {
          url += sep + key;
          sep = '/';
          url += sep + params[key];
        }
      }
    }
    url += sep;

    // add query string
    var sep = '';
    var urlQuery = '';
    for (var key in query) {
      if (query.hasOwnProperty(key)) {
        if (query[key] !== undefined && query[key].length) {
          urlQuery += sep + key + '=' + encodeURIComponent(query[key]);
          sep = '&';
        }
      }
    }
    if (urlQuery.length) {
      urlQuery = '?' + urlQuery;
      url = url + urlQuery;
    }

    if (url !== currentUrl) {

      if (jumpToUrl) {
        window.location.href = url;
      } else {
        filterLoadUrl(url);
      }

    }

    return false;

  }

  function filterInit() {
    const filterLoadMore = document.querySelector('[data-action="filterLoadMore"]');
    if (filterLoadMore) {
      filterLoadMore.addEventListener('click', function(event) {

        var url = filterLoadMore.getAttribute('href');
        filterLoadUrl(url);

        event.preventDefault();

      });
    }
  }

  filterInit();

  // filter keyword input delay
  function delay(callback, ms) {
    var timer = 0;
    return function() {
      var context = this, args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        callback.apply(context, args);
      }, ms || 0);
    };
  }

  document.querySelectorAll('.filters:not(.filters--form) .filter .input').forEach(el => {
    el.addEventListener('keydown', delay(function(event) {
      filterSearch();
    }, 500));
    el.addEventListener('change', delay(function(event) {
      filterSearch();
    }, 500));
  });

  // business directory search filter
  const cbdSearchForm = document.getElementById('business-directory-search');
  if (cbdSearchForm) {
    cbdSearchForm.addEventListener('submit', function(event) {
      filterSearch(true);
      event.preventDefault();
      return false;
    });
  }


});
